import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Checkbox } from "antd";

const AutoFillCheckbox = ({ id, message, handleAutofillAction }) => {
  const [checked, setChecked] = useState(false);

  const handleChange = () => {
    handleAutofillAction(id, !checked);
    setChecked(!checked);
  };

  return (
    <Form.Group className="mb3" controlId={`autofill-${id}`} id={`container_${id}`}>
      <label htmlFor={`autofill-${id}`} className="autofill">
        <Checkbox
          className="checkbox-custom"
          checked={checked}
          name={`autofill-${id}`}
          id={`autofill-${id}`}
          label={message}
          onChange={handleChange}></Checkbox>
        <span className="cb_label_text">{message}</span>
      </label>
    </Form.Group>
  );
};

export default AutoFillCheckbox;
